var map = {
	"./500px-white.svg": "eaf3",
	"./500px.svg": "eee9",
	"./after-effects.svg": "d50c",
	"./behance-white.svg": "2f20",
	"./behance.svg": "c85e",
	"./close.svg": "8b1b",
	"./cpp.svg": "3b5f",
	"./deviantart-white.svg": "a4aa",
	"./deviantart.svg": "0f99",
	"./discord-white.svg": "3cf9",
	"./discord.svg": "e3a3",
	"./dribbble-white.svg": "fec1",
	"./dribbble.svg": "ba48",
	"./email-white.svg": "0e79",
	"./email.svg": "43be",
	"./figma.svg": "170a",
	"./github-white.svg": "629a",
	"./github.svg": "14f6",
	"./go.svg": "6ffb",
	"./illustrator.svg": "0078",
	"./instagram-white.svg": "8376",
	"./instagram.svg": "bd6c",
	"./js.svg": "2087",
	"./linkedin-white.svg": "34aa",
	"./live.svg": "aa5f",
	"./medium-white.svg": "9ece",
	"./medium.svg": "4f40",
	"./menu.svg": "d17f",
	"./nodejs.svg": "5fec",
	"./photoshop.svg": "d138",
	"./php.svg": "59ee",
	"./play.svg": "dab1",
	"./python.svg": "15f7",
	"./react.svg": "d598",
	"./sql.svg": "5ed0",
	"./star.svg": "cc90",
	"./substack-white.svg": "1678",
	"./substack.svg": "5ec1",
	"./vue.svg": "0dcb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";